var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1240_4376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 38.335C32.3665 38.335 38.335 32.3665 38.335 25C38.335 17.6336 32.3665 11.665 25 11.665C17.6336 11.665 11.665 17.6336 11.665 25C11.665 32.3665 17.6336 38.335 25 38.335ZM17.7669 24.7111L30.6241 19.7538C31.2208 19.5382 31.742 19.8994 31.5486 20.8017L31.5497 20.8006L29.3606 31.1141C29.1983 31.8453 28.7638 32.0231 28.156 31.6787L24.8222 29.2217L23.2143 30.7708C23.0365 30.9486 22.8864 31.0986 22.542 31.0986L22.7787 27.7059L28.9572 22.1241C29.2261 21.8874 28.8972 21.7541 28.5427 21.9897L20.9073 26.7969L17.6158 25.7701C16.9012 25.5434 16.8857 25.0556 17.7669 24.7111Z",
    fill: "#0CAF60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1240_4376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.67,
    height: 26.67,
    fill: "white",
    transform: "translate(11.665 11.665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.69fcf817d17926c30e86b2068e9b116c.svg";
export { ForwardRef as ReactComponent };